import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { ClientClient, ClientModel } from '../../api/api';
import useApiClient from './useApiClient';

export default function useApiClients(): UseQueryResult<ClientModel[], Error> {
	const client = useApiClient(ClientClient) as ClientClient;
	return useQuery({
		queryKey: ['clients'],
		queryFn: async () =>
			(
				await client.search({
					paging: {
						pageIndex: 0,
						pageSize: 1000,
						sortBy: 'Name',
						sortAscending: true,
					},
				})
			).items,
	});
}
